import { Injectable, OnDestroy } from '@angular/core';
import {
  map,
  catchError,
  takeUntil,
} from 'rxjs/operators';
import { Observable, Subject, of } from 'rxjs';

import { AuthService } from 'app/services';

@Injectable()
export class IsInternalUserGuardService implements OnDestroy {

  private onDestroy$ = new Subject<void>();

  constructor(
    private readonly authService: AuthService,
  ) {}

  canActivate() {
    return this.authService.user$
    .pipe(
      map(profile => {
        if (profile.isInternal) {
          return true;
        }
        // probably better to redirect to a not authorized page
        return false;
      }),
      catchError(error => of(false)),
      takeUntil(this.onDestroy$)
    );

  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}
